import { render, staticRenderFns } from "./BuyButton.vue?vue&type=template&id=24d6fe41&scoped=true&"
import script from "./BuyButton.vue?vue&type=script&lang=js&"
export * from "./BuyButton.vue?vue&type=script&lang=js&"
import style0 from "./BuyButton.vue?vue&type=style&index=0&id=24d6fe41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6fe41",
  null
  
)

export default component.exports